/* Nura Sense — comportements du thème : panier Ajax, diagnostic, coffret, fiche produit */
(function () {
  'use strict';

  /* ---------- utilitaires ---------- */
  function json(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { console.warn('[nura] JSON invalide:', id, e); return null; }
  }
  function eur(cents) {
    var v = Math.round(cents) / 100;
    var s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  var HATCH = 'repeating-linear-gradient(135deg, rgba(217,198,163,0.08) 0 2px, transparent 2px 10px)';
  function bgOf(img) { return img ? 'url(' + img + ')' : HATCH; }
  function thumb(cls, img) {
    return '<span class="' + cls + '"' + (img ? ' style="background-image:url(' + img + ')"' : '') + '></span>';
  }

  var PRODUCTS = json('nura-products') || [];
  var OBJECTS = json('nura-objects') || [];
  var QUIZ = json('nura-quiz') || [];
  var WHY = json('nura-why') || {};
  var byKey = {};
  PRODUCTS.concat(OBJECTS).forEach(function (p) { byKey[p.key] = p; });

  /* ---------- panier ---------- */
  var cartState = { item_count: 0, items: [], total_price: 0, total_discount: 0 };
  var CFG = json('nura-cart-config') || { freeShip: 6000, coffretMin: 3, coffretPct: 10, resins: [], sugg: [] };
  var ON_CART_PAGE = document.body.classList.contains('template-cart');

  var drawer = document.getElementById('nura-cart');
  var veil = document.getElementById('nura-cart-veil');

  function openCart() { if (drawer) { drawer.classList.add('is-open'); veil && veil.classList.add('is-open'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('is-open'); veil && veil.classList.remove('is-open'); } }
  function busy(on) { if (drawer) drawer.classList.toggle('is-busy', !!on); }

  /* Paliers : remise coffret (nombre d'articles) puis livraison offerte (montant après remise) */
  function goalsHTML() {
    var count = cartState.item_count || 0;
    var total = cartState.total_price || 0;
    var cOk = count >= CFG.coffretMin;
    var sOk = total >= CFG.freeShip;
    var cLeft = CFG.coffretMin - count;
    var cPct = Math.min(100, Math.round(count / CFG.coffretMin * 100));
    var sPct = Math.min(100, Math.round(total / CFG.freeShip * 100));

    var cState = cOk ? 'Appliquée'
      : 'Encore ' + cLeft + ' article' + (cLeft > 1 ? 's' : '');
    var sState = sOk ? 'Offerte'
      : 'Encore ' + eur(CFG.freeShip - total);

    return '' +
      '<div class="nk-goal' + (cOk ? ' is-on' : '') + '">' +
        '<div class="nk-goal-head"><span>Remise coffret · −' + CFG.coffretPct + ' %</span><span class="nk-goal-state">' + cState + '</span></div>' +
        '<div class="nk-track"><div class="nk-fill" style="width:' + cPct + '%"></div></div>' +
      '</div>' +
      '<div class="nk-goal' + (sOk ? ' is-on' : '') + '">' +
        '<div class="nk-goal-head"><span>Livraison offerte</span><span class="nk-goal-state">' + sState + '</span></div>' +
        '<div class="nk-track"><div class="nk-fill" style="width:' + sPct + '%"></div></div>' +
      '</div>' +
      '<p class="nk-goal-note">Remise dès ' + CFG.coffretMin + ' articles · livraison standard offerte dès ' + eur(CFG.freeShip) + ' en France.</p>';
  }

  /* Suggestions : ce qui manque réellement pour faire le rituel */
  function suggestions() {
    var inCart = {};
    var hasResin = false;
    (cartState.items || []).forEach(function (l) {
      inCart[l.handle] = true;
      if ((CFG.resins || []).indexOf(l.handle) >= 0) hasResin = true;
    });
    return (CFG.sugg || []).filter(function (s) {
      if (!s.variant || inCart[s.handle]) return false;
      return hasResin ? s.when === 'resin' : s.when === 'noresin';
    }).slice(0, 2);
  }

  function suggHTML() {
    var list = suggestions();
    if (!list.length) return '';
    return '<p class="nk-sugg-title">Complétez votre rituel</p>' +
      list.map(function (s) {
        return '<div class="nk-sugg-item">' +
          '<span class="nk-sugg-thumb"' + (s.img ? ' style="background-image:url(' + esc(s.img) + ')"' : '') + '></span>' +
          '<div class="nk-sugg-txt"><b>' + esc(s.title) + '</b><small>' + esc(s.why) + '</small></div>' +
          '<button type="button" class="btn-mini nk-sugg-add" data-act="add" data-variant="' + s.variant + '" aria-label="Ajouter ' + esc(s.title) + '">+ ' + eur(s.price) + '</button>' +
        '</div>';
      }).join('');
  }

  function renderExtras() {
    var empty = !cartState.item_count;
    var g = empty ? '' : goalsHTML();
    var s = empty ? '' : suggHTML();
    document.querySelectorAll('[data-cart-goals]').forEach(function (el) { el.innerHTML = g; el.hidden = !g; });
    document.querySelectorAll('[data-cart-sugg]').forEach(function (el) { el.innerHTML = s; el.hidden = !s; });
  }

  function renderCart() {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cartState.item_count; });
    renderExtras();

    var lines = document.getElementById('nura-cart-lines');
    var totalEl = document.getElementById('nura-cart-total');
    var discEl = document.getElementById('nura-cart-discount');
    if (totalEl) totalEl.textContent = eur(cartState.total_price);

    if (discEl) {
      /* Remise réellement appliquée = prix d'origine − total (total_discount peut être en retard après un changement) */
      var disc = Math.max(0, (cartState.original_total_price || 0) - (cartState.total_price || 0));
      if (disc > 0 && cartState.item_count >= CFG.coffretMin) {
        discEl.hidden = false;
        discEl.innerHTML = '<span>Remise coffret appliquée</span><span>−' + eur(disc) + '</span>';
      } else {
        discEl.hidden = true;
      }
    }

    if (!lines) return;
    if (!cartState.items.length) {
      lines.innerHTML = '<p style="font-size:14px;color:#8E8574;line-height:1.8;margin:0">Votre panier est vide. Choisissez une résine, ou composez votre coffret à la carte.</p>';
      return;
    }
    lines.innerHTML = cartState.items.map(function (l) {
      var img = l.image ? l.image.replace(/([.][a-z]+)([?]|$)/i, '_120x$1$2') : '';
      return '<div class="ns-line">' +
        '<div class="ns-line-thumb"' + (img ? ' style="background-image:url(' + img + ')"' : '') + '></div>' +
        '<div style="flex:1;display:flex;flex-direction:column;gap:6px">' +
          '<a href="' + esc(l.url) + '" class="serif" style="font-size:19px;line-height:1.2;color:#EDE7DC">' + esc(l.product_title) + '</a>' +
          '<div style="display:flex;align-items:center;gap:12px">' +
            '<button class="qty-btn" data-line="' + esc(l.key) + '" data-qty="' + (l.quantity - 1) + '" aria-label="Retirer un">−</button>' +
            '<span class="tnum" style="background:none;color:rgba(237,231,220,0.7);font-size:13px">' + l.quantity + '</span>' +
            '<button class="qty-btn" data-line="' + esc(l.key) + '" data-qty="' + (l.quantity + 1) + '" aria-label="Ajouter un">+</button>' +
          '</div>' +
        '</div>' +
        '<span class="serif" style="font-size:19px;color:#D9C6A3">' + eur(l.final_line_price) + '</span>' +
      '</div>';
    }).join('');
  }

  function loadCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; renderCart(); return c; });
  }

  function addItems(items, opts) {
    busy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description || 'Ajout impossible');
        if (ON_CART_PAGE) { window.location.reload(); return; }
        return loadCart();
      })
      .then(function () { busy(false); if (!ON_CART_PAGE && (!opts || opts.open !== false)) openCart(); })
      .catch(function (e) { busy(false); alert(e.message || 'Ajout impossible'); });
  }

  function changeLine(key, qty) {
    busy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (ON_CART_PAGE) { window.location.reload(); return; }
        /* On relit le panier : la réponse de /cart/change.js peut contenir des remises pas encore recalculées */
        return loadCart().then(function () { busy(false); });
      })
      .catch(function () { busy(false); });
  }

  /* ---------- fiche produit en lightbox ---------- */
  var modalHost = document.getElementById('nura-modal-host');
  var openKey = null;

  function renderModal() {
    if (!modalHost) return;
    if (!openKey) { modalHost.innerHTML = ''; document.body.style.overflow = ''; return; }
    var p = byKey[openKey];
    if (!p) { modalHost.innerHTML = ''; return; }
    document.body.style.overflow = 'hidden';
    var specs = '';
    if (p.notes)  specs += '<div><span>Notes</span><span style="color:#D9C6A3;text-align:right">' + esc(p.notes) + '</span></div>';
    if (p.origin) specs += '<div><span>Origine</span><span style="color:#D9C6A3">' + esc(p.origin) + '</span></div>';
    if (p.burn)   specs += '<div><span>Combustion</span><span style="color:#D9C6A3">' + esc(p.burn) + '</span></div>';
    if (p.format) specs += '<div><span>Conditionnement</span><span style="color:#D9C6A3">' + esc(p.format) + '</span></div>';
    modalHost.innerHTML =
      '<div class="ns-modal" data-act="modal-bg">' +
        '<div class="ns-modal-in">' +
          '<div class="ns-modal-img" style="background-image:' + bgOf(p.img) + '"></div>' +
          '<div class="ns-modal-body">' +
            '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:16px">' +
              '<span class="ns-origin">' + esc(p.origin || '') + '</span>' +
              '<button class="btn-link" data-act="modal-close">Fermer</button>' +
            '</div>' +
            '<h3 class="serif" style="font-weight:400;font-size:clamp(30px,3.6vw,44px);margin:0;line-height:1.08">' + esc(p.name) + '</h3>' +
            '<p style="margin:0;font-size:15px;line-height:1.9;color:rgba(237,231,220,0.72)">' + esc(p.desc || '') + '</p>' +
            '<div class="ns-spec">' + specs + '</div>' +
            '<div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:auto">' +
              '<button class="btn-gold" style="padding:17px 28px" data-act="add" data-variant="' + p.variant + '">Ajouter au panier — ' + eur(p.price) + '</button>' +
              (p.url ? '<a class="btn-outline" href="' + esc(p.url) + '" style="padding:17px 28px">Voir la fiche</a>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  /* ---------- diagnostic ---------- */
  var quizPanel = document.getElementById('nura-quiz-panel');
  var qi = 0, scores = {};

  function reco() {
    return PRODUCTS.slice().sort(function (a, b) {
      return (scores[b.key] || 0) - (scores[a.key] || 0);
    })[0];
  }

  function renderQuiz() {
    if (!quizPanel || !QUIZ.length) return;
    if (qi < QUIZ.length) {
      var q = QUIZ[qi];
      quizPanel.innerHTML =
        '<div style="display:flex;flex-direction:column;height:100%">' +
          '<div class="ns-prog">' +
            '<span class="ns-prog-num">' + Math.min(qi + 1, QUIZ.length) + ' / ' + QUIZ.length + '</span>' +
            '<div class="ns-prog-track"><div class="ns-prog-fill" style="width:' + Math.round((qi / QUIZ.length) * 100) + '%"></div></div>' +
          '</div>' +
          '<h3 class="ns-q">' + esc(q.q) + '</h3>' +
          '<div class="ns-opts">' +
            q.options.map(function (o, i) {
              return '<button class="ns-opt" data-act="quiz-answer" data-i="' + i + '">' + esc(o.label) + '</button>';
            }).join('') +
          '</div>' +
        '</div>';
    } else {
      var r = reco();
      if (!r) { quizPanel.innerHTML = ''; return; }
      quizPanel.innerHTML =
        '<div class="ns-reco">' +
          '<span class="ns-kicker" style="letter-spacing:.3em">Votre résine</span>' +
          '<h3>' + esc(r.name) + '</h3>' +
          '<p>' + esc(WHY[r.key] || r.desc || '') + '</p>' +
          '<div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:10px">' +
            '<button class="btn-gold" data-act="add" data-variant="' + r.variant + '">Ajouter — ' + eur(r.price) + '</button>' +
            '<a class="btn-outline" href="' + esc(r.url) + '" style="display:inline-block">Voir la fiche</a>' +
            '<button class="btn-link" data-act="quiz-restart">Recommencer</button>' +
          '</div>' +
        '</div>';
    }
  }

  /* ---------- coffret ---------- */
  var boxResinsEl = document.getElementById('nura-box-resins');
  var boxObjectsEl = document.getElementById('nura-box-objects');
  var boxSummaryEl = document.getElementById('nura-box-summary');
  var boxTotalEl = document.getElementById('nura-box-total');
  var boxHintEl = document.getElementById('nura-box-hint');
  var boxAddEl = document.getElementById('nura-box-add');
  var boxRoot = document.getElementById('nura-coffret');

  var DISCOUNT = boxRoot ? (parseFloat(boxRoot.getAttribute('data-discount')) || 0) : 0;
  var MIN_ITEMS = boxRoot ? (parseInt(boxRoot.getAttribute('data-min'), 10) || 3) : 3;
  var MAX_RESINS = boxRoot ? (parseInt(boxRoot.getAttribute('data-max'), 10) || 3) : 3;
  var pickedResins = [], pickedObjects = [];

  function chipStyle(on) {
    return on ? 'background:rgba(217,198,163,0.10);border:1px solid #D9C6A3'
              : 'background:transparent;border:1px solid rgba(217,198,163,0.2)';
  }

  function renderBox() {
    if (!boxRoot) return;
    if (boxResinsEl) {
      boxResinsEl.innerHTML = PRODUCTS.map(function (p) {
        var on = pickedResins.indexOf(p.key) >= 0;
        var full = !on && pickedResins.length >= MAX_RESINS;
        return '<button class="ns-chip" style="' + chipStyle(on) + (full ? ';opacity:.4' : '') + '" data-act="box-resin" data-key="' + p.key + '"' + (full ? ' disabled' : '') + '>' +
          thumb('ns-chip-thumb', p.img) +
          '<span class="ns-chip-txt"><b>' + esc(p.name) + '</b><small>' + eur(p.price) + '</small></span></button>';
      }).join('');
    }
    if (boxObjectsEl) {
      boxObjectsEl.innerHTML = OBJECTS.map(function (o) {
        var on = pickedObjects.indexOf(o.key) >= 0;
        return '<button class="ns-chip" style="' + chipStyle(on) + '" data-act="box-object" data-key="' + o.key + '">' +
          thumb('ns-chip-thumb', o.img) +
          '<span class="ns-chip-txt"><b>' + esc(o.name) + '</b><small>' + eur(o.price) + (o.meta ? ' · ' + esc(o.meta) : '') + '</small></span></button>';
      }).join('');
    }

    var chosen = pickedResins.concat(pickedObjects).map(function (k) { return byKey[k]; }).filter(Boolean);

    var raw = chosen.reduce(function (t, p) { return t + p.price; }, 0);
    var eligible = chosen.length >= MIN_ITEMS;
    var saving = Math.round(raw * DISCOUNT / 100);
    var total = eligible ? raw - saving : raw;

    if (boxSummaryEl) {
      var rows;
      if (!chosen.length) {
        rows = '<div style="color:#8E8574">Rien de sélectionné.</div>';
      } else {
        rows = chosen.map(function (p) {
          return '<div>' + thumb('ns-sum-thumb', p.img) +
            '<span class="ns-sum-name">' + esc(p.name) + '</span>' +
            '<span>' + eur(p.price) + '</span></div>';
        }).join('');
        rows += '<div class="ns-sum-sub"><span>Sous-total</span><span>' + eur(raw) + '</span></div>';
        rows += '<div class="ns-sum-disc' + (eligible ? ' is-on' : '') + '">' +
                  '<span>Remise coffret · −' + DISCOUNT + ' %</span>' +
                  '<span>−' + eur(saving) + '</span>' +
                '</div>';
      }
      boxSummaryEl.innerHTML = rows;
    }

    if (boxTotalEl) {
      boxTotalEl.innerHTML = eligible
        ? '<span class="ns-total-was">' + eur(raw) + '</span>' + eur(total)
        : eur(total);
    }

    if (boxHintEl) {
      if (!chosen.length) {
        boxHintEl.textContent = 'Choisissez au moins une résine. La remise de ' + DISCOUNT + ' % se déclenche à partir de ' + MIN_ITEMS + ' articles.';
      } else if (eligible) {
        boxHintEl.textContent = 'Coffret assemblé à la main. La remise de ' + DISCOUNT + ' % s’applique automatiquement au paiement.';
      } else {
        var missing = MIN_ITEMS - chosen.length;
        boxHintEl.textContent = 'Encore ' + missing + ' article' + (missing > 1 ? 's' : '') + ' et vous économisez ' + eur(saving) + '.';
      }
    }
    if (boxAddEl) boxAddEl.disabled = chosen.length === 0;
  }

  /* ---------- fiche produit (gabarit) ---------- */
  var pdpMain = document.getElementById('nura-pdp-main');
  if (pdpMain) {
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        var img = pdpMain.querySelector('img');
        if (img && src) img.src = src;
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- délégation des clics ---------- */
  document.addEventListener('click', function (e) {
    var qb = e.target.closest('.qty-btn');
    if (qb && qb.hasAttribute('data-line')) {
      changeLine(qb.getAttribute('data-line'), parseInt(qb.getAttribute('data-qty'), 10));
      return;
    }

    var el = e.target.closest('[data-act]');
    if (!el) return;
    var act = el.getAttribute('data-act');

    if (act === 'cart-open') { e.preventDefault(); openCart(); }
    else if (act === 'cart-close') { closeCart(); }
    else if (act === 'add') {
      e.preventDefault();
      var v = parseInt(el.getAttribute('data-variant'), 10);
      var qty = parseInt(el.getAttribute('data-quantity'), 10) || 1;
      if (v) addItems([{ id: v, quantity: qty }]);
    }
    else if (act === 'modal-open') { openKey = el.getAttribute('data-key'); renderModal(); }
    else if (act === 'modal-close') { openKey = null; renderModal(); }
    else if (act === 'modal-bg') { if (e.target === el) { openKey = null; renderModal(); } }
    else if (act === 'quiz-answer') {
      var opt = QUIZ[qi] && QUIZ[qi].options[parseInt(el.getAttribute('data-i'), 10)];
      if (opt) {
        Object.keys(opt.s || {}).forEach(function (k) { scores[k] = (scores[k] || 0) + opt.s[k]; });
        qi += 1; renderQuiz();
      }
    }
    else if (act === 'quiz-restart') { qi = 0; scores = {}; renderQuiz(); }
    else if (act === 'box-resin') {
      var k = el.getAttribute('data-key');
      var i = pickedResins.indexOf(k);
      if (i >= 0) pickedResins.splice(i, 1);
      else if (pickedResins.length < MAX_RESINS) pickedResins.push(k);
      renderBox();
    }
    else if (act === 'box-object') {
      var ko = el.getAttribute('data-key');
      var io = pickedObjects.indexOf(ko);
      if (io >= 0) pickedObjects.splice(io, 1); else pickedObjects.push(ko);
      renderBox();
    }
    else if (act === 'box-add') {
      var picks = pickedResins.concat(pickedObjects).map(function (x) { return byKey[x]; }).filter(Boolean);
      if (!picks.length) return;
      addItems(picks.map(function (p) { return { id: p.variant, quantity: 1 }; }));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { openKey = null; renderModal(); closeCart(); }
  });
  if (veil) veil.addEventListener('click', closeCart);

  /* ---------- démarrage ---------- */
  renderQuiz();
  renderBox();
  loadCart();
})();
